import { FC } from 'react';
import { QuestionSessionBodyContainerProps } from '../config';
import { observer } from 'mobx-react';
import { useReferentialQuestionContent } from '../../../../hooks/content/useReferentialQuestionContent';
import { useStores } from '../../../../hooks/useStores';

const _ContainDefault: FC<QuestionSessionBodyContainerProps> = ({
  question,
  children
}) => {
  const {question: qstore} = useStores();
  const loading = !qstore.isReady(question._id);
  const { description, question: questionText } = useReferentialQuestionContent(question);
  return children({
    questionId: question._id,
    questionKey: question.key,
    questionType: question.type,
    questionText,
    questionDescription: description,
    questionImage: question.image,
    loading,
  });
};

export const ContainDefault = observer(_ContainDefault);
